<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
>
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-6 h-fit">
			<div class="flex flex-col gap-4">
				<ui-checkbox
					label="Combine Exempt and E-reg costs into a single entry"
					[ngModel]="settings_()?.combineExemptAndEregFees"
					(ngModelChange)="setCombineExemptAndEregFees($event)"
				/>

				<ui-checkbox
					label="Split costs between Trust Ledger and Statement of Account"
					[ngModel]="settings_()?.splitBetweenTlAndSoa"
					(ngModelChange)="setSplitBetweenTlAndSoa($event)"
					*ngIf="!settings_()?.combineExemptAndEregFees"
				/>
			</div>

			<div
				class="flex flex-col gap-4"
				*ngIf="settings_()?.combineExemptAndEregFees"
			>
				<app-direction-of-fee-dropdown
					[currentDirectionOfFee]="settings_()?.location"
					label="Display Line Item(s) In"
					[fieldToUpdate]="locationFieldPath"
				/>

				<ui-checkbox
					label="Subject to HST"
					[ngModel]="settings_()?.hst"
					(ngModelChange)="setHst($event)"
					*ngIf="settings_()?.location === DirectionOfFeeType.SOA"
				/>
			</div>

			<p class="text-orange-darker text-sm">
				<strong>Note:</strong> changes will only apply to new matters to avoid
				impacts to existing Statement of Accounts or Trust Ledgers
			</p>
		</div>
	</div>
</ui-section>
